var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('lingallery',{attrs:{"iid":_vm.currentId,"width":_vm.width,"height":_vm.height,"items":_vm.items},on:{"update:iid":function($event){_vm.currentId=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }